import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./index.css";

import App from "./App";
import NotFound from "./components/NotFound";
import { AuthProvider, useAuth } from "./dashboard/AuthContext";
import Login from "./dashboard/Login";
import Signup from "./dashboard/Signup";
import Dashboard from "./dashboard/Dashboard";

/* ─── Route guard for /dashboard ──────────────────────── */
function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null; // dashboard's own loader will paint after auth resolves
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

/* ─── Top-level route table ───────────────────────────── */
function Root() {
  return (
    <Routes>
      {/* Marketing site at / — keeps the existing single-page App intact */}
      <Route path="/" element={<App />} />
      <Route path="/login"  element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Root />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
